import FormattedMessage from 'I18n/components/FormattedMessage';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { getReportDatasetFromReportResolve } from 'reporting-data/report/reportResolveUtils';
import AILoadingPills from '../../../shared/AILoadingPills';
import InsightComponent from './InsightComponent';
import ReportingAIAssistantInsightsDisclaimer from './ReportingAIAssistantInsightsDisclaimer';
import { getReportDatasetHasNotEnoughDataForAIInsights } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportingAIAssistantContent = ({
  report,
  reportResolve,
  appUsageTracker,
  insightFetch
}) => {
  const reportDatasetIsUndefinedOrHasFewerThan1DataPoint = getReportDatasetHasNotEnoughDataForAIInsights(report, reportResolve);
  if (reportDatasetIsUndefinedOrHasFewerThan1DataPoint) {
    return /*#__PURE__*/_jsx("p", {
      "data-test-id": "report-vis-insights-empty",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.platformReport.reportVisualizationInsights.emptyDataset"
      })
    });
  } else if (isLoading(insightFetch) || !reportResolve) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "report-vis-insights-loading",
      children: /*#__PURE__*/_jsx(AILoadingPills, {
        rows: 3
      })
    });
  } else if (isSucceeded(insightFetch)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        "data-test-id": "report-vis-insights-success",
        children: insightFetch.data.insights.map(insight => /*#__PURE__*/_jsx(InsightComponent, {
          appUsageTracker: appUsageTracker,
          insight: insight,
          correlationId: insightFetch.data.groupCorrelationId,
          report: report,
          dataset: getReportDatasetFromReportResolve(report, reportResolve)
        }, insight.value))
      }), /*#__PURE__*/_jsx(ReportingAIAssistantInsightsDisclaimer, {})]
    });
  } else {
    return /*#__PURE__*/_jsx("p", {
      "data-test-id": "report-vis-insights-failure",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.platformReport.reportVisualizationInsights.error"
      })
    });
  }
};
export default ReportingAIAssistantContent;